export default "__VITE_ASSET__D0XvWTt4__"